import * as type from '../constants/assessmentSectionQuestions';

// GET START CONTENT

export function fetchQuestions(meta = {}) {
    return {
        meta,
        type: type.GET_QUESTIONS,
    };
}

export function fetchQuestionsSuccess(questions) {
    return {
        questions,
        type: type.GET_QUESTIONS_SUCCESS,
    };
}

export function fetchQuestionsFailure(error) {
    return {
        error,
        type: type.GET_QUESTIONS_FAIL,
    };
}

// SAVE PROGRESS

export function saveQuestionsProgress(meta = {}, form = {}) {
    return {
        form,
        meta,
        type: type.SAVE_QUESTIONS_PROGRESS,
    };
}

export function saveQuestionsProgressSuccess(scores) {
    return {
        scores,
        type: type.SAVE_QUESTIONS_PROGRESS_SUCCESS,
    };
}


export function saveQuestionsProgressFailure(error) {
    return {
        error,
        type: type.SAVE_QUESTIONS_PROGRESS_FAIL,
    };
}

// SAVE PARTIAL PROGRESS

export function savePartialQuestionsProgress(meta = {}, form = {}) {
    return {
        form,
        meta,
        type: type.SAVE_PARTIAL_QUESTIONS_PROGRESS,
    };
}

export function savePartialQuestionsProgressSuccess(currentStep) {
    return {
        currentStep,
        type: type.SAVE_PARTIAL_QUESTIONS_PROGRESS_SUCCESS,
    };
}

export function savePartialQuestionsProgressFailure(error) {
    return {
        error,
        type: type.SAVE_PARTIAL_QUESTIONS_PROGRESS_FAIL,
    };
}

// reset queations State
export function resetQuestions() {
    return {
        type: type.RESET_ASSESSMENT_QUESTIONS,
    };
}
